var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[(_vm.itemData.isExtra)?_c('v-icon',{attrs:{"color":"yellow darken-2","left":""}},[_vm._v("mdi-star")]):_vm._e(),_vm._v(_vm._s(_vm.itemData.boardBasis)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dea0e462","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/labels/BasisLabel.vue
// module id = null
// module chunks = 